import React from "react";

import { useTranslation } from "utils";

import { Button, Icon } from "components";

export const CourseModuleFooter = ({ activeModule, complete, moduleCompletionLoading, onComplete, onChangeModule }) => {
  const { t } = useTranslation("courses");
  return (
    <div className="module-footer">
      {complete ? (
        <Button className="complete-button padding-right-350" type="primary">
          {t("module.complete")}
          <Icon className="check-mark" iconName="tabler/circle-check" />
        </Button>
      ) : (
        <Button className="complete-button" loading={moduleCompletionLoading} onClick={onComplete}>
          {t("module.markComplete")}
        </Button>
      )}
      <div className="module-footer-nav">
        <div
          className={`module-footer-nav-control ${activeModule.previousModuleId < 0 ? "disabled" : ""}`}
          onClick={() => onChangeModule(activeModule.previousModuleId)}
        >
          <Icon iconName="tabler/arrow-left" />
        </div>
        <div
          className={`module-footer-nav-control ${activeModule.nextModuleId < 0 ? "disabled" : ""}`}
          onClick={() => onChangeModule(activeModule.nextModuleId)}
        >
          <Icon iconName="tabler/arrow-right" />
        </div>
      </div>
    </div>
  );
};
